import { PaymentMethods } from 'ui/forms/Onboarding/shared';

export const {
    Form,
    useForm,
    getInitialValues
} = PaymentMethods;

export type PaymentMethod = PaymentMethods.PaymentMethod;
export type OnboardingPaymentMethodsForm = PaymentMethods.OnboardingPaymentMethodsForm;
